export const colors = {
  primary: {
    light: '#C9EBC1',
    main: '#5CC244',
    dark: '#408830',
  },
  purple: {
    ultraLight: '#E0C8DC',
    light: '#C191B9',
    main: '#832474',
    dark: '#530048',
  },
  blue: {
    light: '#B6E8EE',
    main: '#0DB2C7',
    dark: '#0A91A2',
    sky: '#8CCDFA',
    deep: '#002841',
  },
  yellow: '#EBDA2F',
  lime: '#D4FC37',
  warning: '#E6A64C',
  error: '#E6564C',
  white: '#FFFFFF',
  black: '#1F1D1C',
  background: '#F4F4F4',
  text: {
    contrastText: '#FFFFFF',
  },
}

export const general = {
  spacingBase: 6,
  defaultBorderRadius: 12,
}

export const costSavingsChart = {
  threeSixtySavingsBatteryColor: '#6E1B61',
  threeSixtySavingsWallboxColor: '#D68DB5',
  consumptionPriceColor: '#88ADA4',
  dynamicEmsNormalOperationColor: '#5CC244',
  dynamicEmsGridChargeColor: '#007F5F',
  dynamicEmsBlockDischargingColor: '#D4FC37',
}

export const systemChartColors = {
  BatPowerIn: '#79841c',
  BatPowerOut: '#9AC353',
  NetIn: '#00A4CE',
  NetOut: '#0A91A2',
  ASOC: '#D1E2AF',
  DC_PowerL1: '#F57F17',
  DC_PowerL2: '#FFC238',
  DC_PowerL3: '#FFAA66',
  DC_PowerSolar: '#FFC238',
  DC_PowerTotal: '#FF6600',
  ForecastPower: '#FFC238',
  ThreeSixtySavings: '#50C695',
  NetOutWithoutThreeSixtySavings: '#AFAFAF',
  Autarky: '#007F5F',
  WeatherBreakthrough: '#FFC238',
  ConsumptionTotal: '#A26A42',
  ConsumptionHouse: '#cc3333',
  DirectConsumption: '#EF7510',
  DirectConsumptionProduction: '#cc3333',
  Deration: '#FF6600',
  SelfProduction: '#0D0980',
  Wallbox_energyAll: '#118899',
  Wallbox_energySolar: '#118699',
  Wallbox_energyNetOut: '#116499',
  Wallbox_energyDischarged: '#ECC690',
  Powermeter_NetIn: '#6633FF',
  Powermeter_NetOut: '#E15D38',
  Powermeter_production: '#6633FF',
  Powermeter_consumption: '#E15D38',
  Powermeter_NetIn_alien: '#6633FF',
  Powermeter_NetOut_alien: '#E15D38',
  Powermeter_NetIn_enera: '#00aaa5',
  Powermeter_NetIn_bypass: '#9AD2FF',
  Powermeter_NetIn_bypass_noCharge: '#9AD2FF',
  Custom_Sum: '#666666',
  GreenConsumption: '#c73639',
  Temperature: '#ffbf00',
}

export const liveView = {
  liveViewItem: '#832474',
  liveViewBranch: '#1A8FC8',
  energyBubble: '#832474',
  energyBubbleActive: '#83bada',
  batteryIconFill: '#D7E9BB',
  flowIndicatorOutColor: '#FFC300',
  flowIndicatorInColor: '#5CC244',
}

export const wallboxWidget = {
  charging: '#5CC244',
  chargingStripes: '#C9EBC1',
  discharging: '#E0C8DC',
  dischargingStripes: '#832474',
}

export const batteryWidget = {
  progressBar: '#5CC244',
  progressBarStripes: '#C9EBC1',
}

export const eMobilityChartColors = {
  totalEnergyChargedBar: '#0DB2C7',
  totalGridChargedBarV1: '#99e4f6',
  totalGridChargedBar: '#12A5D3',
  totalGridChargedBarLightestShade: '#33c6ea',
  totalChargedBackground: '#BBDEE9',
  totalDischargedEnergyCardBackground: '#FAE6E6',
  totalDischargedEnergyBackgroundV1: '#CC6601',
  totalDischargedEnergyBackground: '#ADE2F2',
  solarChargedBarV1: '#EBDA2F',
  solarChargedBar: '#EBDA2F',
  solarChargedBarLightestShade: '#FFF485',
  solarChargedBackground: '#F4EFB9',
  solarStatCardIcon: '#E6A64C',
  chargeDurationCardBackground: '#C9EBC1',
  dynamicTariffChartAreaBackgroundColor: '#686868',
  dynamicTariffChartAreaStrokeColor: '#616161',
  dynamicTariffChartDotColor: '#4A4A4A',
  dynamicTariffChartReferenceLineColor: '#AFAFAF',
}
